import { DataTable } from "primereact/datatable";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Toolbar } from "primereact/toolbar";
import { AutoComplete } from "primereact/autocomplete";
import { Button } from "primereact/button";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";
interface IConsultantList {
    id?: number,
    consultant_ID?: number,
    consultant_Email_ID?: number,
    consultant_Name?: string,
    send_Email?: boolean,
    updated_By?: string,
    updated_On?: Date,
}

export const ConsultantTable = (toast: any) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IConsultantList[], loading: boolean });
    const [value2, setValue2] = useState({ consultant_ID: 0, consultant_Name: "" } as { consultant_ID: number | null, consultant_Name: string | null });
    const [consultant, setConsultant] = useState<Array<any>>();
    const [totalRecords, setTotalRecords] = useState(0);
    const dt = useRef<any>(null);

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'login_ID',
        sortOrder: -1
    });

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = () => {
        return <p>Timesheet Email Sending Setting Consultant Wise</p>;
    }

    const toggleStatus = async (id: number) => {
        const response = await Fetch(`Timesheet/updateSendEmailConsultant`, "PUT", null, `id=${id}`, toast);
        if (response) {
            loadTableData(value2?.consultant_Name || "0_0_1");
        }
    }

    const updatedOn = (rowData: any) => {
        let date;
        if (rowData.updated_On) date = format(new Date(rowData.updated_On), 'dd/MM/yyyy HH:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async (name: string) => {
        setTableData({ tableData: tableData.tableData, loading: true });

        const response = await Fetch(`Timesheet/getConsultantList`, "GET", null, `name=${name}&lazyParams=${JSON.stringify(lazyParams)}`, toast);
        if (response) {
            const data: { totalRecords: number, data: Array<IConsultantList> } = await response.json();

            setTableData({ tableData: data.data, loading: false });
            setTotalRecords(data.totalRecords);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        loadConsultant(event.query);
    }

    const rightToolbarTemplate = () => {
        return <>
            <AutoComplete suggestions={consultant} completeMethod={completeMethodConsultant} field={"consultant_Name"} forceSelection value={value2} placeholder={"Search Consultant"} onChange={(e) => setValue2(e.value)} />
            <Button icon="pi pi-search" className="p-button p-button-info mr-2" onClick={() => {
                loadTableData(value2?.consultant_Name || "0_0_1");
            }} />
        </>
    }

    useEffect(() => {
        loadTableData(value2?.consultant_Name || "0_0_1");
    }, [lazyParams]);

        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        const DateFormat = loginObj?.date_Format;
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", height: "67vh" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="60vh"
                lazy dataKey="id" showGridlines responsiveLayout="scroll"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                value={tableData.tableData} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="consultant_Email_ID" header="Consultant Email" />
                <Column field="send_Email" header="Send Email" body={(rowData: any) => <p onClick={() => toggleStatus(rowData.id)} style={{ color: (rowData.send_Email === true) ? "green" : "red" }} className="cursor-pointer">{rowData.send_Email === true ? "Yes" : "No"}</p>} />
                <Column field="updated_By" header="Updated By" />
                {/* <Column field="updated_On" header="Updated On" body={updatedOn} /> */}
                <Column field="updated_On" header="Updated On" body={(rowData : any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy",  DateFormat, true)} />
            </DataTable>
        </>
    );
}